import "../styles/testimonialcard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

const TestimonialCard = ({ testimonial }) => {
  const { name, rating, img, comment } = testimonial;
  return (
    <div className="testimonial-container">
      <div className="person-info">
        <img src={img} alt={"Photo of " + name} className="person-img" />
        <h3>{name}</h3>
      </div>
      <div>
        <div className="stars-container">
          {Array.from({ length: rating }, (_, i) => i + 1).map((i) => (
            <FontAwesomeIcon key={i} icon={faStar} size="lg" className="star-icon" />
          ))}
        </div>
        <p className="comment">{"\""}{comment}{"\""}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;
